/* eslint-disable no-unused-expressions */
import React, { useEffect } from "react";
import Stacks from "../components/Stacks/index";
import Drawer from "../components/funtComponents/DrawerLeft";
import { mapStateToProps } from "../components/funtComponents/models/buscar";
import { connect } from "react-redux";
import SigninPage from "./signin";
import { useNavigate } from "react-router-dom";

const Home = (props) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    !props.idBuscar ? navigate("/") : null;
  }, [props.idBuscar, navigate]);
  return (
    <>
      {!props.idBuscar ? (
        <SigninPage />
      ) : (
        <>
          <Drawer />
          <Stacks />
        </>
      )}
    </>
  );
};

export default connect(mapStateToProps, null)(Home);
